

  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import LockerChip from "@/components/shared/chips/LockerChip.vue";
  import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue";
  import ChannelChip from "@/components/shared/chips/ChannelChip.vue";
  import CommunityChip from "@/components/shared/chips/CommunityChip.vue";

  @Component({
    components: {ChannelChip, ServiceProviderChip, LockerChip, CommunityChip}
  })
  export default class PermissionTargetChip extends Vue {

    @Prop()
    protected targetId!: number;
    @Prop()
    protected targetClass!: string;
    @Prop()
    protected targetName!: string;
    @Prop()
    protected targetDeletedAt!: string;

    created() {}

    protected get shortClassName(): string {
      return this.targetClass
        ? (this.targetClass.split(('\\')).pop() || '')
        : '';
    }

    protected get isLocker(): boolean {
      return this.shortClassName == 'LockerInterface';
    }

    protected get isServiceProvider(): boolean {
      return this.shortClassName == 'ServiceProviderInterface';
    }

    protected get isChannel(): boolean {
      return this.shortClassName == 'ChannelInterface';
    }

    protected get isCommunity(): boolean {
      return this.shortClassName == 'CommunityInterface';
    }

    protected get deletedClass(): string {
      return this.targetDeletedAt ? 'line--through' : '';
    }

  }

